// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_UUID.eqUUID);
var OrderUUIDIsSymbol = {
    reflectSymbol: function () {
        return "OrderUUID";
    }
};
var OrderUUID = function (x) {
    return x;
};
var toFillFormTypeOrderUUID = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeOrderUUID_ = {
    Coercible0: function () {
        return undefined;
    }
};
var eqOrderUUID = {
    eq: function (x) {
        return function (y) {
            return eq(x)(y);
        };
    }
};
var genericOrderUUID = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showOrderUUID = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderUUID)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_UUID.showUUID))(OrderUUIDIsSymbol))
};
var unscrambleDecodeOrderUUID = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderUUID)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Data_UUID.udecodeUUID)))(Unscramble_Generic.defaultOptions)
};
var encodeOrderUUID = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericOrderUUID)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OrderUUIDIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UUID.encodeUUID))))
};
var decodeOrderUUID = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericOrderUUID)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OrderUUIDIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UUID.decodeUUID)))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    OrderUUID,
    genericOrderUUID,
    eqOrderUUID,
    showOrderUUID,
    encodeOrderUUID,
    decodeOrderUUID,
    unscrambleDecodeOrderUUID,
    toFillFormTypeOrderUUID,
    newtypeOrderUUID_
};
